<fieldset>
  <div class="is-flex is-align-items-center gap-xs">
    <img
      class="logo"
      src="/maternite.png"
      alt="icone soins"
      height="48"
      width="48" />
    <h3>{{ 'tarificateur.maternity' | translate }}</h3>
  </div>
  <p class="mb-3">
    {{ 'option.minmedical' | translate }}
    {{ 'option.beneficiaryselected' | translate }}
  </p>
  <mat-radio-group
    [formControl]="fc"
    class="is-flex is-flex-direction-column gap-s">
    <acs-expandable-radio-button
      [canExpand]="false"
      [expanded]="expandedOption === 0"
      (expandedChange)="expandPanel(0)">
      <mat-radio-button
        [value]="options[0].level"
        [disabled]="options[0].disable">
        <span class="is-size-6">{{ options[0].label | translate }}</span>
      </mat-radio-button>
    </acs-expandable-radio-button>

    <acs-expandable-radio-button
      [expanded]="expandedOption === 1"
      (expandedChange)="expandPanel(1)">
      <mat-radio-button
        [value]="options[1].level"
        [disabled]="options[1].disable">
        <span class="is-size-6">{{ options[1].label | translate }}</span>
      </mat-radio-button>
      <div details class="option-detail">
        <span class="option-detail-title">{{ 'tarificateur.option.detail_title' | translate }}</span>
        <div class="option-detail-info">
          <span class="option-detail-info-label">{{ 'tarificateur.option.maternity.limit_year_beneficiary.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.maternity.limit_year_beneficiary.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.maternity.pregnancy.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.maternity.pregnancy.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.maternity.childbirth_complication.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.maternity.childbirth_complication.description.lv1' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.maternity.assisted_procreation.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.maternity.assisted_procreation.description.lv1' | translate"></span>

          <span class="option-detail-info-link"><a [href]="guaranteesTableLink" target="_blank">{{ 'tarificateur.option.guarantees_table_link' | translate }}</a></span>
        </div>
      </div>
    </acs-expandable-radio-button>

    <acs-expandable-radio-button
      [expanded]="expandedOption === 2"
      (expandedChange)="expandPanel(2)">
      <mat-radio-button
        [value]="options[2].level"
        [disabled]="options[2].disable">
        <span class="is-size-6">{{ options[2].label | translate }}</span>
      </mat-radio-button>
      <div details class="option-detail">
        <span class="option-detail-title">{{ 'tarificateur.option.detail_title' | translate }}</span>
        <div class="option-detail-info">
          <span class="option-detail-info-label">{{ 'tarificateur.option.maternity.limit_year_beneficiary.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.maternity.limit_year_beneficiary.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.maternity.pregnancy.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.maternity.pregnancy.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.maternity.childbirth_complication.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.maternity.childbirth_complication.description.lv2' | translate"></span>

          <span class="option-detail-info-label">{{ 'tarificateur.option.maternity.assisted_procreation.title' | translate }}</span>
          <span [innerHTML]="'tarificateur.option.maternity.assisted_procreation.description.lv2' | translate"></span>

          <span class="option-detail-info-link"><a [href]="guaranteesTableLink" target="_blank">{{ 'tarificateur.option.guarantees_table_link' | translate }}</a></span>
        </div>
      </div>
    </acs-expandable-radio-button>
  </mat-radio-group>
  <h4 class="my-2">
    {{ 'tarificateur.maternity.beneficiary' | translate }}
  </h4>

  <mat-form-field class="width-full">
    <mat-select
      id="materniteoptionsouscrite"
      [formControl]="beneficiariesFC">
      @for (item of optionsPopulate; track item.label) {
        <mat-option
          [value]="item.value"
          [disabled]="sectionDisabled">
          <span class="is-size-6">{{ item.label | translate }}</span>
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</fieldset>
